// extracted by mini-css-extract-plugin
module.exports = {"description":"_2VcxnR1NDCe9xmFmqBo7Wd"};